import { render, staticRenderFns } from "./pagelayout.vue?vue&type=template&id=01e31f6b&scoped=true&"
import script from "./pagelayout.vue?vue&type=script&lang=js&"
export * from "./pagelayout.vue?vue&type=script&lang=js&"
import style0 from "./pagelayout.vue?vue&type=style&index=0&id=01e31f6b&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01e31f6b",
  null
  
)

component.options.__file = "pagelayout.vue"
export default component.exports